import {
  Component,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as debug from 'debug';
import { ConfigProvider } from '../../providers/config/config';

declare let CmKit: any;

@Component({
  selector: 'invite-friends',
  templateUrl: 'invite-friends.html',
})
export class InviteFriendsComponent {
  log = debug('app:InviteFriendsComponent');

  @Input() entryPoint = '';

  @ViewChild('inviteFriendsSlideOver') inviteSlideover;

  LAST_CLOSED_KEY = 'invite-banner-configs';

  subHeader = 'Get rewarded for your invites!';
  inviteBanner = false;
  showSlideover = false;
  clickedRemoveBanner = false;
  friendsTotalSinceLastInvite;
  inviteKarmaMiles = 0;
  lastClosedBanner;
  isUsersFirstWeek = false;
  hasClosedToday = true;
  numFriends = 0;
  karmaMiles = 0;
  allowedEntryPoints = [];

  constructor(
    public tools: ToolsProvider,
    public user: UserProvider,
    public configs: ConfigProvider
  ) {}

  ngOnInit() {
    this.allowedEntryPoints = this.configs.get('inviteFriendsEntryPoints');
    this.inviteKarmaMiles =
      _.get(this.configs.get('karmaMiles'), 'inviteUser', 10) *
      _.get(this.configs.get('karmaMiles'), 'inviteMaxSends', 1);

    this.setSubHeader();

    this.lastClosedBanner = localStorage.getItem(this.LAST_CLOSED_KEY);

    this.hasClosedToday = moment()
      .subtract(1, 'day')
      .isBefore(this.lastClosedBanner);

    this.isUsersFirstWeek = moment()
      .subtract(7, 'days')
      .isBefore(this.user.get('dates.created'));

    this.numFriends = _.get(this.user.info, 'stats.events.friend', 0);
    this.karmaMiles = _.get(this.user.info, 'stats.events.karmaMile', 0);

    if (_.includes(this.allowedEntryPoints, this.entryPoint)) {
      this.showHideCriteria(this.entryPoint);
    }
  }

  inviteFriend() {
    this.inviteSlideover.show();
  }

  setSubHeader() {
    if (this.entryPoint === 'profilePage') {
      this.subHeader = 'Grow your circle, get rewarded';
    } else if (this.entryPoint === 'speedBump') {
      this.subHeader =
        'Grow your circle, get rewarded. Earn Karma miles for each friend you successfully invite to the app!';
    }
  }

  /**
  Feed        - show if it is 1st week of user in app or if karma miles less than 50
              - if all else false show on ever 5th open limit 1 per day
  Friends     - visible at all times unless user closes then will be hidden until next app open after one day
  Profile      - visible at all times unless user closes then will be hidden until next app open after one day
  Messages    - visible at all times unless user closes then will be hidden until next app open after one day
  Speed Bump  - show after ever 6th post
   */
  showHideCriteria(page, clicked?) {
    switch (page) {
      case 'topHomeFeed':
        if (this.isUsersFirstWeek || this.karmaMiles < 50) {
          this.inviteBanner = !this.hasClosedToday;
        } else {
          const nOpens = 5;
          const nOpensMod =
            _.get(this.user.info, 'stats.events.openApp', 0) % nOpens;

          if (nOpensMod === 0) {
            this.inviteBanner = !this.hasClosedToday;
          } else {
            this.inviteBanner = false;
          }
        }

        break;

      // case 'profilePage':
      // case 'speedBump':
      // case 'friends':
      // case 'friendsList':
      //   this.inviteBanner = !this.hasClosedToday;
      default:
        this.inviteBanner = !this.hasClosedToday;
        break;
    }
  }

  removeBanner(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.inviteBanner = false;

    localStorage.setItem(this.LAST_CLOSED_KEY, new Date().toISOString());
  }
}



// WEBPACK FOOTER //
// ./src/components/invite-friends/invite-friends.ts